module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-formula__container"
  }, [(_vm.innerMultiplicand.method === 'multiplicand_percentage') ? _c('control', {
    attrs: {
      "label": "Enter percentage",
      "for": "own_total_figure",
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerMultiplicand.percentage),
      expression: "innerMultiplicand.percentage"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "max": "100",
      "min": "1"
    },
    domProps: {
      "value": (_vm.innerMultiplicand.percentage)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerMultiplicand, "percentage", $event.target.value)
      }, _vm.updateMultiplicand]
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.innerMultiplicand.method === 'multiplicand_percentage' ||
    _vm.innerMultiplicand.method === 'multiplicand_default') ? _c('div', {
    staticClass: "flex-grid m-formula"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex-grid m-formula__item--row"
  }, [(!_vm.hasMultipleDependants && _vm.innerMultiplicand.method === 'multiplicand_default') ? _c('p', [_vm._v("2/3 x [ ")]) : _vm._e(), _vm._v(" "), (_vm.hasMultipleDependants && _vm.innerMultiplicand.method === 'multiplicand_default') ? _c('p', [_vm._v("75% x [ ")]) : _vm._e(), _vm._v(" "), (_vm.innerMultiplicand.method === 'multiplicand_percentage') ? _c('p', [_c('input', {
    staticClass: "a-form-inputs--readonly",
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.innerMultiplicand.percentage
    }
  }), _vm._v("% x [\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    staticClass: "a-form-inputs--readonly",
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.theDeceasedNetIncome
    }
  })]), _vm._v(" "), _c('p', [_vm._v("+")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    staticClass: "a-form-inputs--readonly",
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.dependantsNetIncome
    }
  })]), _vm._v(" "), _c('p', [_vm._v("] -")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    staticClass: "a-form-inputs--readonly",
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.dependantsNetIncome
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid m-formula__item--row"
  }, [_c('p', [_vm._v("Total =")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    staticClass: "a-form-inputs--readonly",
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.innerMultiplicand.total
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.innerMultiplicand.method === 'multiplicand_pounds') ? _c('control', {
    attrs: {
      "label": "Enter own dependency in £",
      "for": "own_total_figure",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerMultiplicand.user),
      expression: "innerMultiplicand.user"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.innerMultiplicand.user)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerMultiplicand, "user", $event.target.value)
      }, _vm.updateMultiplicand]
    }
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid m-formula__item--row"
  }, [_c('b', [_vm._v("Dependency Formula")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19b1aa1e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/dependency/steps/dependency-on-income/Mutiplicand.vue
// module id = 1593
// module chunks = 0